import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Star, MapPin, Calendar, Users } from 'lucide-react';

export const TripCard = ({ trip }) => {
  return (
    <Link to={`/trips/${trip.slug}`} data-testid={`trip-card-${trip.slug}`}>
      <Card className="group overflow-hidden border-0 shadow-sm hover:shadow-xl transition-shadow duration-300">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={trip.image_url}
            alt={trip.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <div className="absolute top-4 left-4">
            <Badge className="bg-secondary text-white border-0">
              {trip.trip_type === 'both' ? 'Group & Solo' : trip.trip_type === 'group' ? 'Group Tour' : 'Solo Adventure'}
            </Badge>
          </div>
          <div className="absolute bottom-4 left-4 right-4">
            <h3 className="font-heading text-xl font-semibold text-white mb-1">{trip.title}</h3>
            <div className="flex items-center gap-1 text-white/80 text-sm">
              <MapPin className="h-3 w-3" />
              <span>{trip.destination}</span>
            </div>
          </div>
        </div>
        <CardContent className="p-4 space-y-3">
          {trip.show_reviews && trip.rating > 0 && (
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1">
                <Star className="h-4 w-4 fill-secondary text-secondary" />
                <span className="font-medium">{trip.rating}</span>
                <span className="text-muted-foreground text-sm">({trip.review_count} reviews)</span>
              </div>
            </div>
          )}
          
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <Calendar className="h-4 w-4" />
              <span>{trip.duration_days} Days</span>
            </div>
            <div className="flex items-center gap-1">
              <Users className="h-4 w-4" />
              <span>Max {trip.max_group_size}</span>
            </div>
          </div>

          <div className="flex items-center justify-between pt-2 border-t">
            <div>
              <span className="text-sm text-muted-foreground">From</span>
              <p className="font-heading text-2xl font-semibold text-primary">${trip.price.toLocaleString()}</p>
            </div>
            <div className="text-right">
              <span className="text-sm text-muted-foreground">or</span>
              <p className="text-sm font-medium text-secondary">
                ${Math.round(trip.price / 12)}/mo
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
